import { render } from "./InstrumentDetailPage.vue?vue&type=template&id=0fbac8af&scoped=true"
import script from "./InstrumentDetailPage.vue?vue&type=script&lang=js"
export * from "./InstrumentDetailPage.vue?vue&type=script&lang=js"

import "./InstrumentDetailPage.vue?vue&type=style&index=0&id=0fbac8af&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fbac8af"]])

export default __exports__